<template>
  <el-table-column
    prop="supplier.last_name"
    sortable="custom"
    label="Átadó"
    show-overflow-tooltip
    min-width="120"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.supplier_name"
        style="display: inline-block;"
      >
        {{ scope.row.supplier_name }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'supplier.last_name',
  };
</script>
